import { DocumentNode, gql } from '@apollo/client'

export const GET_NEWS_NOT_VIEWED: DocumentNode = gql`
    query GetNewsNotViewed {
        getNewsNotViewed
    }
`
